export const LESSONS_BULK_SAVE_WAIT_TIME_MILLIS = 5000;



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/lesson.constants.ts